import React from 'react';
import {
  OnboardingContext,
  ONBOARDING_ACTION,
  Question,
  SurveyStepWithIndex,
} from '../../../contexts/onboarding';
import TypeForm from '../Typeform';
interface AnswerQuestionParams {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  answer: any;
  index: number;
}

export default function TrackTypeform({
  submitAnswers,
  stepIndex,
  isLoading,
}: {
  submitAnswers: () => void;
  stepIndex: number;
  isLoading: boolean;
}) {
  const [onboardingState, dispatch] = React.useContext(OnboardingContext);

  // This will throw an error if survey[stepIndex] doesn't exist
  const { questions, currentIndex } = onboardingState.track.survey[stepIndex];

  const onAnswerQuestion = ({ answer, index }: AnswerQuestionParams) => {
    dispatch({
      type: ONBOARDING_ACTION.TRACK.ANSWER_SURVEY_QUESTION,
      payload: {
        answer,
        questionIndex: index,
        stepIndex,
      },
    });
  };

  const onIncrementSurvey = () => {
    dispatch({
      type: ONBOARDING_ACTION.TRACK.INCREMENT_SURVEY_STEP,
      payload: {
        stepIndex,
      },
    });
  };

  const onDecrementSurvey = () => {
    dispatch({
      type: ONBOARDING_ACTION.TRACK.DECREMENT_SURVEY_STEP,
      payload: {
        stepIndex,
      },
    });
  };

  const survey = onboardingState.track.survey;

  const totalSteps = survey
    .map((step: SurveyStepWithIndex) => step.questions)
    .flat().length;

  const completedSteps = survey
    .map((step: SurveyStepWithIndex) => step.questions)
    .flat()
    .filter((question: Question) => question.isAnswered).length;

  return (
    <TypeForm
      questions={questions}
      currentIndex={currentIndex}
      onAnswerQuestion={onAnswerQuestion}
      onIncrementSurvey={onIncrementSurvey}
      onDecrementSurvey={onDecrementSurvey}
      onSubmitAnswers={submitAnswers}
      totalSteps={totalSteps}
      currentStep={completedSteps}
      isLoading={isLoading}
    />
  );
}
